"use client";

import Image from "next/image";
import Link from "next/link";
import type { Collection } from "@/features/collections/types";
import { toCollectionView, useCollectionToggles } from "./collectionView";
import { ChainChip, CollectionCreator, CollectionLogo, CollectionName, CollectionToggles } from "./CollectionParts";

/**
 * THE /collection GRID CARD — a collection drawn as what it is, a deck of
 * works. The banner is the top plate; two sheets of the same art sit behind
 * it, and on hover the deck fans open. The logo is mounted on the plate's
 * foot, the rank rides the top corner on the Top tab (gold for the first
 * three), and the whole card is one stretched link with the two toggles and
 * the creator link above it.
 */
export default function CollectionStackCard({
  collection,
  lang,
  rank
}: {
  collection: Collection;
  lang: "fa" | "en";
  rank?: number;
}) {
  const v = toCollectionView(collection, lang);
  const t = useCollectionToggles(collection, lang);
  const num = new Intl.NumberFormat(lang === "fa" ? "fa-IR" : "en-US");
  const deck = {
    ["--clx-art" as string]: `url("${v.banner}")`
  };
  return <article className="v2-clx-card" data-podium={rank !== undefined && rank <= 3 ? rank : undefined}>
      <Link className="v2-clx-card-link v2-focus" href={v.href} aria-label={v.name} />
      <div className="v2-clx-deck" style={deck}>
        <span className="v2-clx-sheet v2-clx-sheet--back" aria-hidden />
        <span className="v2-clx-sheet v2-clx-sheet--mid" aria-hidden />
        <span className="v2-clx-plate">
          <Image src={v.banner} alt="" fill loading="lazy" sizes="(max-width: 619px) 50vw, (max-width: 1023px) 33vw, 22vw" style={{
          objectFit: "cover"
        }} />
          <span className="v2-clx-plate-shade" aria-hidden />
        </span>
        {rank !== undefined ? <span className="v2-clx-rank" aria-label={lang === "fa" ? `رتبه‌ی ${num.format(rank)}` : `Rank ${rank}`}>{num.format(rank)}</span> : null}
        <CollectionToggles t={t} num={num} />
        <CollectionLogo v={v} size={58} className="v2-clx-card-logo" />
      </div>
      <div className="v2-clx-card-body">
        <CollectionName v={v} lang={lang} />
        <div className="v2-clx-card-meta">
          <CollectionCreator v={v} lang={lang} />
          <ChainChip v={v} />
        </div>
      </div>
    </article>;
}